const emailChecker = (data) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const emailChecked = emailRegex.test(data);
    
    return emailChecked;
}

export default emailChecker;